module.exports = __webpack_public_path__ + "img/icon-study.f0940846.svg";